import axios from "axios";
import Config from "../../config/";
import moment from "moment";
import { encryptPayload } from "../../utils/encryption";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

export function encrypted(text) {
  return encryptPayload(text);
}

export function cekAuth() {
  return {
    headers: {
      Authorization: API_KEY + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data"
    }
  };
}

function pushloggingx(requests, description) {
  const url = `${ROOT_URL}logactivity/logactivity/`;
  let ippublic = "-";

  const fdata = new FormData();
  fdata.append("user_id", localStorage.getItem("id"));
  fdata.append("name", localStorage.getItem("name"));
  fdata.append("email", localStorage.getItem("email"));
  fdata.append("issuperuser", localStorage.getItem("is_superuser"));
  fdata.append("ipaddress", localStorage.getItem("ipaddress"));
  fdata.append("location", localStorage.getItem("location"));
  fdata.append("date_created", moment().format("YYYY-MM-DD HH:mm:ss"));
  fdata.append("os", "");
  fdata.append("activity", requests);
  fdata.append("description", description);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function fetchVessellName(call_sign) {
  const url = `${ROOT_URL}gpsapirt/checkcallsign/?call_sign=${encrypted(
    call_sign
  )}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchVessellist() {
  const url = `${ROOT_URL}vessellist/vessellist/?limit=1000`;
  const request = axios.get(url, cekAuth());
  pushloggingx("get " + url, "Akses halaman Masterdata (Pertamina Vessel)");
  return request;
}

export function fetchVessellistSearch(call_sign) {
  const url = `${ROOT_URL}vessellist/vessellist/?search=${call_sign}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchProfile() {
  const url = `${ROOT_URL}api/profile/?limit=5000`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function deleteVessellist(id) {
  const url = `${ROOT_URL}vessellist/vessellist/${id}/`;

  const request = axios.delete(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx(
    "delete " + url,
    "Menghapus data vessel masterdata pertamina vessel"
  );
  return request;
}

export function pushVessellist(body) {
  const url = `${ROOT_URL}vessellist/vessellist/`;

  const fdata = new FormData();
  fdata.append("vessel_name", body.vessel_name);
  fdata.append("vessel_captain", body.vessel_captain);
  fdata.append("imo", body.imo);
  fdata.append("mmsi", body.mmsi);
  fdata.append("ship_id", body.ship_id);
  fdata.append("programer_id", body.programer_id);
  fdata.append("flag", body.flag);
  fdata.append("fuel_main_engine", body.fuel_main_engine);
  fdata.append("proggramer", body.proggramer);
  fdata.append("proggramer_phone_ext", body.proggramer_phone_ext);
  fdata.append("proggramer_mobile_phone", body.proggramer_mobile_phone);
  fdata.append("email", body.email);
  fdata.append("password", body.password);
  fdata.append("vessel_number", body.vessel_number);
  fdata.append("grt", body.grt);
  fdata.append("vessel_type", body.vessel_type);
  fdata.append("call_sign", body.call_sign);
  fdata.append("fuel_aux_engine", body.fuel_aux_engine);
  fdata.append("speed", body.speed);
  fdata.append("vessel_owner", body.vessel_owner);
  fdata.append("dwt", body.dwt);
  fdata.append("yob", body.yob);
  fdata.append("cost_center", body.cost_center);
  fdata.append("vessel_status", body.vessel_status);
  fdata.append("ownership_status", body.ownership_status);
  fdata.append("vessel_category", body.vessel_category);
  fdata.append("cot_procurement", body.cot_procurement);
  fdata.append("cot_actual", body.cot_actual);
  fdata.append("loa", body.loa);
  fdata.append("draft", body.draft);
  fdata.append("technical_fleet", body.technical_fleet);
  fdata.append("tank_capacity", body.tank_capacity);
  fdata.append("cctv_status", "-");

  //fdata.append('updated_at', moment(body.updated_at,'YYYY-MM-DD'));+
  fdata.append("expired_date", moment().format("YYYY-MM-DD"));

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx(
    "post " + url,
    "Menambahkan data vessel masterdata pertamina vessel"
  );
  return request;
}

export function pushGpsapitd(body) {
  const url = `${ROOT_URL}gpsapirt/gpsapirt/`;

  const fdata = new FormData();
  fdata.append("shipname", body.vessel_name);
  fdata.append("imo", body.imo);
  fdata.append("course", "0");
  fdata.append("elapsed", "0");
  fdata.append("type_img", "0");
  fdata.append("mmsi", body.mmsi);
  fdata.append("ship_id", body.ship_id);
  fdata.append("programer_id", body.programer_id);
  fdata.append("flag", body.flag);
  fdata.append("call_sign", body.call_sign);
  fdata.append("speed", "0");
  fdata.append("dwt", body.dwt);
  fdata.append("lat", "0");
  fdata.append("lon", "0");
  fdata.append("shiptype", "0");
  fdata.append("heading", "0");
  fdata.append("status_name", null);
  fdata.append("type_img", 0);
  fdata.append("type_name", null);
  fdata.append("country_code", null);
  fdata.append("reported_draught", null);
  fdata.append("dest_class", null);
  fdata.append("port_data_x", null);
  fdata.append("port_data_y", null);
  fdata.append("last_pos", null);
  fdata.append("last_pos_tooltip", null);
  fdata.append("timezone_offset", null);
  fdata.append("show_load_status", null);
  fdata.append("vsl_length", null);
  fdata.append("vsl_code", null);
  fdata.append("type_summary", null);
  fdata.append("country", null);
  fdata.append("draught", null);
  fdata.append("last_port_id", null);
  fdata.append("last_port_name", null);
  fdata.append("last_port_country", null);
  fdata.append("last_port_unlocode", null);
  fdata.append("next_port_id", null);
  fdata.append("next_port_name", null);
  fdata.append("next_port_country", null);
  fdata.append("next_port_unlocode", null);
  fdata.append("station_id", null);
  fdata.append("rot", null);
  fdata.append("destination", null);
  fdata.append("width", null);
  fdata.append("length", null);
  fdata.append("source_api", "GPS");
  fdata.append("sog", null);
  fdata.append("geofenceport_status", 0);
  fdata.append("geofencesungai_status", 0);
  fdata.append("geofenceport_name", "");
  fdata.append("date_created", moment().format("YYYY-MM-DD HH:mm:ss"));
  fdata.append("vessel_status", body.vessel_status);
  fdata.append("vessel_category", body.vessel_category);
  fdata.append("vessel_container", "");
  fdata.append("remark", "");

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function pushFleetrt(body) {
  const url = `${ROOT_URL}fleetrt/fleetrt/`;

  const fdata = new FormData();
  fdata.append("shipname", body.vessel_name);
  fdata.append("imo", body.imo);
  fdata.append("course", "0");
  fdata.append("elapsed", "0");
  fdata.append("type_img", "0");
  fdata.append("mmsi", body.mmsi);
  fdata.append("ship_id", body.ship_id);
  fdata.append("programer_id", body.programer_id);
  fdata.append("flag", body.flag);
  fdata.append("call_sign", body.call_sign);
  fdata.append("speed", "0");
  fdata.append("dwt", body.dwt);
  fdata.append("lat", "0");
  fdata.append("lon", "0");
  fdata.append("shiptype", "0");
  fdata.append("heading", "0");
  fdata.append("status_name", null);
  fdata.append("type_img", 0);
  fdata.append("type_name", null);
  fdata.append("country_code", null);
  fdata.append("reported_draught", null);
  fdata.append("dest_class", null);
  fdata.append("port_data_x", null);
  fdata.append("port_data_y", null);
  fdata.append("last_pos", null);
  fdata.append("last_pos_tooltip", null);
  fdata.append("timezone_offset", null);
  fdata.append("show_load_status", null);
  fdata.append("vsl_length", null);
  fdata.append("vsl_code", null);
  fdata.append("type_summary", null);
  fdata.append("country", null);
  fdata.append("draught", null);
  fdata.append("last_port_id", null);
  fdata.append("last_port_name", null);
  fdata.append("last_port_country", null);
  fdata.append("last_port_unlocode", null);
  fdata.append("next_port_id", null);
  fdata.append("next_port_name", null);
  fdata.append("next_port_country", null);
  fdata.append("next_port_unlocode", null);
  fdata.append("station_id", null);
  fdata.append("rot", null);
  fdata.append("destination", null);
  fdata.append("width", null);
  fdata.append("length", null);
  fdata.append("source_api", "AIS_MT");
  fdata.append("sog", null);
  fdata.append("geofenceport_status", 0);
  fdata.append("geofencesungai_status", 0);
  fdata.append("geofenceport_name", "");
  fdata.append("date_created", moment().format("YYYY-MM-DD HH:mm:ss"));
  fdata.append("vessel_status", body.vessel_status);
  fdata.append("vessel_category", body.vessel_category);
  fdata.append("vessel_container", "");
  fdata.append("remark", "");

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function pushUpdateFleetrt(body) {
  const url = `${ROOT_URL}fleetrt/updatefleet/`;

  const fdata = new FormData();
  fdata.append("shipname", encrypted(body.vessel_name));
  fdata.append("imo", encrypted(body.imo));
  fdata.append("shiptype", encrypted("0"));
  fdata.append("type_img", encrypted("0"));
  fdata.append("mmsi", encrypted(body.mmsi));
  fdata.append("ship_id", encrypted(body.ship_id));
  fdata.append("programer_id", encrypted(body.programer_id));
  fdata.append("flag", encrypted(body.flag));
  fdata.append("shiptype", encrypted(body.vessel_type));
  fdata.append("call_sign", encrypted(body.call_sign));
  fdata.append("dwt", encrypted(body.dwt));
  fdata.append("vessel_status", encrypted(body.vessel_status));

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function pushDeleteGpsapirt(ship_id) {
  const url = `${ROOT_URL}gpsapirt/deletegpsapirt/`;

  const fdata = new FormData();
  fdata.append("ship_id", encrypted(ship_id));
  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function pushDeleteFleetrt(ship_id) {
  const url = `${ROOT_URL}fleetrt/deletefleetrt/`;

  const fdata = new FormData();
  fdata.append("ship_id", encrypted(ship_id));
  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function pushUpdateGpsapirt(body) {
  const url = `${ROOT_URL}gpsapirt/updategpsapirt/`;

  const fdata = new FormData();
  fdata.append("shipname", encrypted(body.vessel_name));
  fdata.append("imo", encrypted(body.imo));
  fdata.append("shiptype", encrypted("0"));
  fdata.append("type_img", encrypted("0"));
  fdata.append("mmsi", encrypted(body.mmsi));
  fdata.append("ship_id", encrypted(body.ship_id));
  fdata.append("programer_id", encrypted(body.programer_id));
  fdata.append("flag", encrypted(body.flag));
  fdata.append("shiptype", encrypted(0));
  fdata.append("call_sign", encrypted(body.call_sign));
  fdata.append("dwt", encrypted(body.dwt));
  fdata.append("vessel_status", encrypted(body.vessel_status));

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function updateVessellist(body) {
  const url = `${ROOT_URL}vessellist/vessellist/${body.id}/`;

  const fdata = new FormData();
  fdata.append("vessel_name", body.vessel_name);
  fdata.append("vessel_captain", body.vessel_captain);
  fdata.append("imo", body.imo);
  fdata.append("mmsi", body.mmsi);
  fdata.append("flag", body.flag);
  fdata.append("fuel_main_engine", body.fuel_main_engine);
  fdata.append("proggramer", body.proggramer);
  fdata.append("programer_id", body.programer_id);
  fdata.append("proggramer_phone_ext", body.proggramer_phone_ext);
  fdata.append("proggramer_mobile_phone", body.proggramer_mobile_phone);
  fdata.append("email", body.email);
  fdata.append("password", body.password);
  fdata.append("vessel_number", body.vessel_number);
  fdata.append("grt", body.grt);
  fdata.append("vessel_type", body.vessel_type);
  fdata.append("call_sign", body.call_sign);
  fdata.append("fuel_aux_engine", body.fuel_aux_engine);
  fdata.append("speed", body.speed);
  fdata.append("vessel_owner", body.vessel_owner);
  fdata.append("ship_id", body.ship_id);
  fdata.append("dwt", body.dwt);
  fdata.append("yob", body.yob);
  fdata.append("cost_center", body.cost_center);
  fdata.append("vessel_status", body.vessel_status);
  fdata.append("ownership_status", body.ownership_status);
  fdata.append("vessel_category", body.vessel_category);
  fdata.append("cot_procurement", body.cot_procurement);
  fdata.append("cot_actual", body.cot_actual);
  fdata.append("loa", body.loa);
  fdata.append("draft", body.draft);
  fdata.append("technical_fleet", body.technical_fleet);
  fdata.append("tank_capacity", body.tank_capacity);
  fdata.append("cctv_status", "-");
  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx(
    "update " + url,
    "Mengedit data vessel masterdata pertamina vessel"
  );
  return request;
}

export function proccessUpload(fileupload, ext) {
  const url = `${ROOT_URL}fileupload/uploadfile/`;

  const fdata = new FormData();
  fdata.append("fileupload", fileupload);
  fdata.append("ext", ext);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}
